module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Picture Credits")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The following organisations and individuals kindly supplied the illustrations featured on the pages listed.")]), _vm._v(" "), _c('p', {
    staticClass: "pict"
  }, [_vm._v("J. Bakken collection: "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg321img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("321")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("Behmüller collection: "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#pg63img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")]), _vm._v(" (top),")]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("Briggs collection: "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#pg42img1"
    }
  }, [_vm._v("42")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#pg43img1"
    }
  }, [_vm._v("43")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05#pg84img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#pg133img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("Denham: "), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06#pg109img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("Dreyer collection, via T. Eggan: "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05#pg87img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("A. Duncan via E. Skjold: "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#pg36img1"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("T. Eggan collection: "), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06#pg113img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg295img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("295")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg296img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("296")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg325img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("325")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("E. Ettrup collection: "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#pg63img2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")]), _vm._v(" (bottom)")]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("Festningsverk collection: "), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#pg239img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("239")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg319img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("319")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("Forsvarsgalleriet: "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#pg147img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("Forsvarsgalleriet via Søren Nørby: "), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07#pg120img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")]), _vm._v(" (all)")]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("Forsvarets museer, Oslo: "), _c('a', {
    attrs: {
      "href": "#/xhtml/02_Dedication#pgiiimg1"
    }
  }, [_vm._v("ii")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05#pg90img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter09#pg167img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("167")]), _vm._v(" (both, Regulations for Orograph), "), _c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter10#pg177img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("177")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#pg243img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("243")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#pg244img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("244")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#pg245img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("245")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#pg246img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("246")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter13#pg261img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("261")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg291img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("291")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg293img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("293")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg306img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("306")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg309img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("309")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("Geirr Haarr collection: "), _c('a', {
    attrs: {
      "href": "#/xhtml/03_Title#pgiiiimg1"
    }
  }, [_vm._v("iii")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#pg2img1"
    }
  }, [_vm._v("2")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#pg4img1"
    }
  }, [_vm._v("4")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#pg5img1"
    }
  }, [_vm._v("5")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#pg6img1"
    }
  }, [_vm._v("6")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#pg7img1"
    }
  }, [_vm._v("7")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#pg8img1"
    }
  }, [_vm._v("8")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#pg9img1"
    }
  }, [_vm._v("9")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#pg10img1"
    }
  }, [_vm._v("10")]), _vm._v(" (both), "), _c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter02#pg19img1"
    }
  }, [_vm._v("19")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter02#pg20img1"
    }
  }, [_vm._v("20")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#pg29img1"
    }
  }, [_vm._v("29")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#pg31img1"
    }
  }, [_vm._v("31")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#pg35img1"
    }
  }, [_vm._v("35")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#pg39img1"
    }
  }, [_vm._v("39")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#pg44img1"
    }
  }, [_vm._v("44")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#pg45img1"
    }
  }, [_vm._v("45")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#pg50img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#pg52img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#pg56img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#pg59img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#pg65img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05#pg74img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05#pg79img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05#pg88img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06#pg100img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100–1")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06#pg102img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06#pg103img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06#pg104img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06#pg107img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06#pg108img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07#pg117img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07#pg119img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07#pg121img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07#pg126img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07#pg127img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07#pg130img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#pg137img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#pg142img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter10#pg176img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("176")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter10#pg182img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("182")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#pg229img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("229")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#pg233img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("233")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#pg234img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("234–5")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#pg236img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("236")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#pg248img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("248")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#pg250img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("250")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter13#pg263img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("262–3")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter13#pg269img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("269")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter13#pg275img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("275")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter13#pg278img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("278")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg290img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("290")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg292img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("292")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg313img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("313")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg314img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("314")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg315img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("315")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg317img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("317")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg318img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("318")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg320img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("320")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg322img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("322")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg323img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("323")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg324img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("324")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter15#pg328img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("328")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter15#pg331img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("331")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter15#pg333img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("333")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter15#pg334img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("334")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter15#pg335img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("335")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter15#pg337img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("337")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter15#pg339img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("339")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter16#pg340img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("340")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter16#pg341img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("341")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter16#pg343img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("343")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter16#pg344img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("344")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter16#pg345img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("345")]), _vm._v(" (both), "), _c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter16#pg347img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("347")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter17#pg357img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("357")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("Hosar collection: "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg312img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("312")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("H. Hovdet collection: "), _c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter09#pg172img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("172")]), _vm._v(" Abram Joslin via Antonio Bonomi: "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#pg12img1"
    }
  }, [_vm._v("12–13")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#pg14img1"
    }
  }, [_vm._v("14–15")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#pg210img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("210–11")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("T. Kjosvold/Forsvaret: "), _c('a', {
    attrs: {
      "href": "#/xhtml/01_Halftitle#pgiimg1"
    }
  }, [_vm._v("i")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter16#pg348img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("348")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("Kit Layman: "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#pg134img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("Lillesand bymuseum: "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#pg140img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#pg143img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("Marinemuseet Horten: "), _c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter02#pg23img1"
    }
  }, [_vm._v("23")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter02#pg25img1"
    }
  }, [_vm._v("25")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07#pg125img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter09#pg163img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("163")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter10#pg178img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("178")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter10#pg179img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("179")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter10#pg181img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("181")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#pg199img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("199")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#pg222img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("222")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter13#pg254img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("254")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter13#pg259img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("258–9")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter13#pg260img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("260")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter13#pg261img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("261")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter13#pg264img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("264")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("Melien/Fjeld collection: "), _c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter09#pg171img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("171")]), _vm._v(" (both), "), _c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter10#pg186img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("186")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter10#pg187img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("187")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#pg202img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("202–3")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("NARA, Washington DC: "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05#pg72img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")]), _vm._v(" (E180-24b); "), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#pg249img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("249")]), _vm._v(" (PG-48289); "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg285img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("285")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg289img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("289")]), _vm._v(" (both E279-01)")]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("National Archives, Kew: "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg299img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("299")]), _vm._v(" (NA-FO 371/24834)")]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("Normann-Anno Domkirkeodden via Digitalmuseet: "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg287img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("287")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("NTB: "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05#pg82img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#pg151img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("151")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#pg152img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg286img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("286")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("Riksarkivet, Oslo: "), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07#pg129img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#pg205img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("205")]), _vm._v(" (RA-PA-1469); "), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#pg214img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("214–15")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#pg216img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("216")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#pg219img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("219")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#pg220img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("220")]), _vm._v(" (both), "), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#pg223img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("223")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#pg224img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("224")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#pg227img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("227")]), _vm._v(" (RA-PA-1209); "), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#pg230img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("230")]), _vm._v(" (RA-II-C-11 2000)")]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("Royal Navy Submarine Museum, Gosport: "), _c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter15#pg336img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("336")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("E. Skjold collection: "), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07#pg116img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#pg138img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#pg139img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter09#pg164img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("164")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter09#pg165img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("165")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter09#pg169img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("169")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter09#pg170img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("170")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#pg192img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("192")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#pg236img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("236")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#pg237img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("237")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#pg238img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("238")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#pg240img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("240")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#pg252img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("252")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#pg253img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("253")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter13#pg273img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("273")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter13#pg276img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("276")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter13#pg277img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("277")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter17#pg358img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("358")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("Asbjørn Svarstad: "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#pg57img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("Svenska RA, Krigsarkivet, Forshell: "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05#pg93img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_c('a', {
    attrs: {
      "href": "http://Trojmiasto.wyborcza.pl",
      "target": "_blank"
    }
  }, [_vm._v("Trojmiasto.wyborcza.pl")]), _vm._v(": "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#pg141img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])]), _vm._v(" "), _c('p', {
    staticClass: "pic"
  }, [_vm._v("A. Wilmar collection: "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#pg135img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#pg200img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("200")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter13#pg267img1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("267")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f892c67","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Picture.vue
// module id = 75
// module chunks = 0